import React from "react";
import Map from "../../../commons/formFields/Map";
import { Alert, Input, Modal, Spin, Divider } from "antd";
import ImageUploadButton from "../../website/ImageUploaderButton";
import { deleteImage } from "../../../../services/firebaseService/endPoints/admin/website";
import useCreateLocation from "./useCreateLocation";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import GroupSelector from "../../../../CommonComponents/GroupSelector/GroupSelector";
import { ChantButton, ChantInput, ChantSelect, ChantCheckbox } from "../../../../CommonComponents";

const TYPES = [
  "Watch Party",
  "Where We Meet",
  "Meet-up",
  "Pub",
  "Hotel",
  "Tailgate",
  "Stadium",
  "Tifo",
  "Volunteering",
];

const CreateLocations = ({ onCloseModal }) => {
  const {
    saving,
    loading,
    childRef,
    formData,
    adminData,
    showModal,
    errorInForm,
    locationData,
    locationImage,
    mapUpdate,
    handleMapOK,
    toggleModal,
    handleSubmit,
    updateAddress,
    locationClear,
    setLocationImage,
    handleInputChange,
    handleModalChange,
    handleErrorMessageClose,
    dashboardType,
    selectedGroups,
    childGroupDetails,
    handleGroupSelectionChange,
  } = useCreateLocation(onCloseModal);

  return (
    <div className="col">
      {errorInForm.isError && errorInForm.visible && (
        <div className="mx-5 mt-2">
          <Alert
            message="Error"
            description={errorInForm.message}
            type="error"
            closable
            afterClose={handleErrorMessageClose}
          />
        </div>
      )}

      {showModal ? (
        <div>
          <Modal
            open={showModal}
            width="80vw"
            onOk={handleMapOK}
            onCancel={toggleModal}
          >
            {
              <Map
                address={locationData.address}
                onRef={(ref) => {
                  childRef.current = ref;
                }}
                mapUpdate={mapUpdate}
                lat={locationData.latitude}
                long={locationData.longitude}
                place_id={locationData.placeId}
                updateAddress={updateAddress}
              />
            }
          </Modal>
        </div>
      ) : (
        <div></div>
      )}
      <div className="md-5 border-box" style={{ padding: "12px" }}>
        <ScreenHeader title="Add Location" />
        <div
          style={{
            padding: "12px",
            marginTop: "2px",
            backgroundColor: "#ffffff",
          }}
        >
          {loading ? (
            <div
              className="flex-center"
              style={{ height: "40vh", width: "100%" }}
            >
              <Spin tip="Loading..." />
            </div>
          ) : (
            <div className="chant-form-body">
              {dashboardType === "clubadmin" && (
                <div style={{ marginBottom: "20px" }}>
                  <GroupSelector
                    selectedGroups={selectedGroups}
                    allGroups={childGroupDetails}
                    onChange={handleGroupSelectionChange}
                    typeLabel="Who should see this location?"
                  />
                  <Divider style={{ margin: "16px 0" }} />
                </div>
              )}
              <div style={{ marginBottom: "24px" }}>
                <ChantSelect
                  label="Location Type"
                  value={formData?.type || undefined}
                  onChange={(value) => handleInputChange(undefined, "type", value)}
                  placeholder="--Select Location Type--"
                  required
                  listHeight={400}
                  options={TYPES.map((t) => ({ value: t, label: t }))}
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <ChantInput
                  label="Name"
                  value={formData?.name || ""}
                  onChange={handleInputChange}
                  name="name"
                  required
                  tabIndex="2"
                  maxLength={25}
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <ChantInput
                  label="Location URL"
                  value={formData?.url || ""}
                  onChange={handleInputChange}
                  name="url"
                  tabIndex="2"
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Location Address<span style={{ color: "#ff0000" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <ChantButton type="primary" onClick={handleModalChange} tabIndex="2">
                    Select Address
                  </ChantButton>
                  <p
                    style={{
                      margin: 0,
                      flex: 1,
                      color: locationData?.address ? "#000" : "#999",
                      fontSize: "14px",
                      fontWeight: locationData?.address ? "500" : "400",
                      fontStyle: locationData?.address ? "normal" : "italic",
                    }}
                  >
                    {locationData?.address || "No address selected"}
                  </p>
                  {locationData?.address && (
                    <ChantButton type="secondary" onClick={locationClear}>
                      Clear
                    </ChantButton>
                  )}
                </div>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Location Image<span style={{ color: "#ff0000" }}>*</span>
                </label>
                <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <ImageUploadButton
                    text="Upload Image"
                    onDelete={(file) => {
                      if (file.url) {
                        let path = `${adminData.groupName}/locations/`;
                        deleteImage(
                          `${path}/`,
                          "locationImage",
                          adminData.id
                        );
                      }
                    }}
                    images={[locationImage]}
                    aspectRatio={1}
                    onSave={(images) => {
                      images && setLocationImage(images[0]);
                    }}
                  />
                  <p style={{ fontSize: 14, margin: 0 }}>
                    Used on website and directory. 1x1 aspect ratio.
                  </p>
                </div>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>Location Details</label>
                <Input.TextArea
                  tabIndex="2"
                  maxLength={250}
                  style={{ fontSize: "16px" }}
                  placeholder="(optional) Enter brief description (max 250 chars). Used on website and directory."
                  value={formData?.details}
                  name="details"
                  onChange={handleInputChange}
                  rows={4}
                />
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Is this the club&apos;s primary stadium?
                </label>
                <ChantCheckbox
                  checked={formData?.isClubPrimaryStadium}
                  onChange={(e) =>
                    handleInputChange(undefined, "isClubPrimaryStadium", e.target.checked)
                  }
                />
              </div>

              <Divider className="my-2" />

              <div className="d-flex justify-content-center my-2">
                <ChantButton loading={saving} onClick={handleSubmit}>
                  Submit
                </ChantButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateLocations;
